export function LoadingState() {
  return (
    <div className="flex items-center justify-center h-full min-h-[400px]">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        <div className="mt-4 text-slate-400">Loading...</div>
      </div>
    </div>
  );
}

export function StatsStripSkeleton() {
  return (
    <div className="bg-slate-900 border-b overflow-x-auto">
      <div className="flex gap-4 px-4 py-3">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="min-w-[80px] h-20 bg-slate-700 rounded-lg animate-shimmer" />
        ))}
      </div>
    </div>
  );
}

export function RaceCardSkeleton() {
  return (
    <div className="bg-slate-900 rounded-lg shadow-md p-4 border border-slate-700">
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <div className="h-6 bg-slate-700 rounded w-24 mb-2 animate-shimmer"></div>
          <div className="h-4 bg-slate-700 rounded w-48 animate-shimmer"></div>
        </div>
        <div className="h-6 w-20 bg-slate-700 rounded-full animate-shimmer"></div>
      </div>
      <div className="h-4 bg-slate-700 rounded w-full mt-4 animate-shimmer"></div>
    </div>
  );
}

export function ErrorState({ error, onRetry }) {
  return (
    <div className="flex items-center justify-center h-full min-h-[400px]">
      <div className="text-center max-w-md px-4">
        <div className="text-6xl mb-4">⚠️</div>
        <h3 className="text-xl font-bold text-white mb-2">
          Something went wrong
        </h3>
        <p className="text-slate-400 mb-4">
          {error?.message || 'An unexpected error occurred'}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ icon = '🔍', title, description, action }) {
  return (
    <div className="flex items-center justify-center h-full min-h-[300px]">
      <div className="text-center max-w-md px-4">
        <div className="text-6xl mb-4">{icon}</div>
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        <p className="text-slate-400 mb-4">{description}</p>
        {action}
      </div>
    </div>
  );
}
